export interface VariavelTemplate {
  ordem: number;
  valor: string;
}

export interface VariavelBotao {
  titulo: string;
  valor: string;
  tipo:string;
}

export class EnvioMensagemTemplate {
  id?: string;
  templateId: number;
  templateNome: string;
  textoCorpo: string;
  textoCabecalho: string;
  textoRodape: string;
  idioma: string;
  contato: string;
  nomeContato: string;
  urlImagem: string;
  variaveis: VariavelTemplate[] = [];
  botoes: VariavelBotao[] = [];
  canalId?: number;
  fluxoId?: number;
  etapaId?: number

  constructor(
    templateId: number,
    templateNome: string,
    textoCorpo: string,
    textoCabecalho: string,
    textoRodape: string,
    idioma: string,
    contato: string,
    nomeContato: string,
    urlImagem: string,
    exemplos?: { ordem: number; valor?: string }[],
    botoes?: { titulo: string; valor: string, tipo:string }[],
    canalId?: number,
    fluxoId?: number,
    etapaId?: number
  ) {
    this.templateId = templateId;
    this.templateNome = templateNome;
    this.textoCorpo = textoCorpo;
    this.textoCabecalho = textoCabecalho;
    this.textoRodape = textoRodape;
    this.idioma = idioma;
    this.contato = contato;
    this.nomeContato = nomeContato;
    this.urlImagem = urlImagem;
    this.canalId = canalId;
    this.fluxoId = fluxoId;
    this.etapaId = etapaId;
    if (exemplos?.length) {
      this.variaveis = exemplos.map((exemplo) => ({
        ordem: exemplo.ordem,
        valor: exemplo.valor || '',
      }));
    }
    if (botoes?.length) {
      this.botoes = botoes.map((botao) => ({
        titulo: botao.titulo || '',
        valor: botao.valor || '',
        tipo: botao.tipo || '',
      }));
    }
  }

  atualizarValor(ordem: number, novoValor: string): void {
    const variavel = this.variaveis.find((v) => v.ordem === ordem);
    if (variavel) {
      variavel.valor = novoValor;
    }
  }
}
